import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const MobileBottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const [showMore, setShowMore] = useState(false);

  // Hide on admin/dashboard paths where sidebar exists
  const hiddenPaths = ['/admin-login', '/admin-register', '/admin-dashboard'];
  if (hiddenPaths.some(p => location.pathname.startsWith(p))) return null;

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  // Determine dashboard path based on user type
  const getDashboardPath = () => {
    if (!user) return '/login';
    if (user.tipo === 'agenzia') return '/dashboard-agenzia';
    if (user.tipo === 'fiorista') return '/dashboard-fiorista';
    if (user.tipo === 'professionista') return '/dashboard-professionista';
    return '/area-privata';
  };

  const getDashboardLabel = () => {
    if (!user) return 'Accedi';
    if (user.tipo === 'agenzia') return 'Agenzia';
    return 'Profilo';
  };

  const getDashboardIcon = () => {
    if (!user) return 'login';
    if (user.tipo === 'agenzia') return 'business';
    return 'person';
  };

  const navItems = [
    { path: '/', icon: 'home', label: 'Home' },
    { path: '/necrologi', icon: 'search', label: 'Cerca' },
    { path: '/associazioni', icon: 'favorite', label: 'Donazioni' },
    { path: getDashboardPath(), icon: getDashboardIcon(), label: getDashboardLabel() },
  ];

  const moreItems = [
    { path: '/blog', icon: 'article', label: 'Blog' },
    { path: '/fiori', icon: 'local_florist', label: 'Fiori' },
    { path: '/cimiteri', icon: 'park', label: 'Cimiteri' },
    { path: '/libro-della-memoria', icon: 'auto_stories', label: 'Libro Memoria' },
    { path: '/contatti', icon: 'mail', label: 'Contatti' },
    { path: '/faq', icon: 'help', label: 'FAQ' },
  ];

  return (
    <>
      {/* More menu overlay */}
      {showMore && (
        <div className="fixed inset-0 z-[998] bg-black/40 backdrop-blur-sm md:hidden" onClick={() => setShowMore(false)}>
          <div
            className="absolute bottom-[72px] left-0 right-0 bg-white rounded-t-2xl shadow-2xl p-4 animate-slide-up"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="w-10 h-1 bg-gray-300 rounded-full mx-auto mb-4" />
            <div className="grid grid-cols-3 gap-3">
              {moreItems.map((item) => (
                <button
                  key={item.path}
                  onClick={() => { navigate(item.path); setShowMore(false); }}
                  className={`flex flex-col items-center gap-1.5 p-3 rounded-xl transition-colors ${
                    isActive(item.path) ? 'bg-amber-50 text-amber-700' : 'text-gray-600 hover:bg-gray-50'
                  }`}
                  data-testid={`mobile-more-${item.label.toLowerCase().replace(/\s/g, '-')}`}
                >
                  <span className="material-symbols-outlined text-xl">{item.icon}</span>
                  <span className="text-[10px] font-medium leading-tight text-center">{item.label}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Bottom Navigation Bar */}
      <nav
        className="fixed bottom-0 left-0 right-0 z-[999] bg-white/95 backdrop-blur-lg border-t border-gray-200 md:hidden safe-area-bottom"
        data-testid="mobile-bottom-nav"
      >
        <div className="flex items-center justify-around h-[68px] px-2 max-w-lg mx-auto">
          {navItems.map((item) => (
            <button
              key={item.path}
              onClick={() => { navigate(item.path); setShowMore(false); }}
              className={`flex flex-col items-center justify-center gap-0.5 w-16 h-full transition-all ${
                isActive(item.path)
                  ? 'text-amber-700'
                  : 'text-gray-500'
              }`}
              data-testid={`mobile-nav-${item.label.toLowerCase()}`}
            >
              <div className={`relative flex items-center justify-center w-8 h-8 rounded-full transition-all ${
                isActive(item.path) ? 'bg-amber-100 scale-110' : ''
              }`}>
                <span className={`material-symbols-outlined text-[22px] ${
                  isActive(item.path) ? 'font-bold' : ''
                }`} style={isActive(item.path) ? { fontVariationSettings: "'FILL' 1" } : {}}>
                  {item.icon}
                </span>
              </div>
              <span className={`text-[10px] leading-tight ${
                isActive(item.path) ? 'font-bold' : 'font-medium'
              }`}>{item.label}</span>
            </button>
          ))}

          {/* More button */}
          <button
            onClick={() => setShowMore(!showMore)}
            className={`flex flex-col items-center justify-center gap-0.5 w-16 h-full transition-all ${
              showMore ? 'text-amber-700' : 'text-gray-500'
            }`}
            data-testid="mobile-nav-more"
          >
            <div className={`relative flex items-center justify-center w-8 h-8 rounded-full transition-all ${
              showMore ? 'bg-amber-100 scale-110' : ''
            }`}>
              <span className="material-symbols-outlined text-[22px]"
                style={showMore ? { fontVariationSettings: "'FILL' 1" } : {}}>
                {showMore ? 'close' : 'menu'}
              </span>
            </div>
            <span className={`text-[10px] leading-tight ${showMore ? 'font-bold' : 'font-medium'}`}>
              {showMore ? 'Chiudi' : 'Altro'}
            </span>
          </button>
        </div>
      </nav>
    </>
  );
};

export default MobileBottomNav;
